import { HelpPageContentViewModel } from '@fora-monorepo/epi-content-common';
import { Box, Container, Link, ParsedHtmlContent, WideBox } from '@foradevelopment/fora-ui';

type HelpPageContentProps = {
  content: HelpPageContentViewModel | null;
  backToLink: string;
  backLabel: string;
};

export const HelpPageContent = ({ content, backToLink, backLabel }: HelpPageContentProps) => {
  return (
    <Box marginLeft="auto" marginRight="auto" maxWidth={600}>
      <Box maxWidth={578} marginBottom={60}>
        {content?.ingress ? (
          <ParsedHtmlContent htmlContent={content.ingress.body} styling={{ fontSize: 'large' }} />
        ) : null}
        <Container marginTop={20}>
          <Link to={backToLink} fontSize="medium" iconLeft>
            {backLabel}
          </Link>
        </Container>
      </Box>
      {content?.helpSections?.length ? (
        <>
          {content.helpSections.map((section, index) => (
            <WideBox key={index} backgroundColor="white" marginBottom={2}>
              <ParsedHtmlContent htmlContent={section.body} styling={{ fontSize: index ? 'standard' : 'medium' }} />
              {section.links?.map((link, lindex) => (
                <Container key={lindex} marginTop={10}>
                  <Link to={link.url}>{link.text}</Link>
                </Container>
              ))}
            </WideBox>
          ))}
        </>
      ) : null}
    </Box>
  );
};
